<template>
  <header class="header">
    <div class="header__inner">

      <!--  Navigation   -->
      <nav class="header__nav">
        <ul class="header__list">

          <li class="header__item">
            <router-link :to="{name: 'Home'}" class="header__link">{{ $t('home.home') }}</router-link>
          </li>

          <li class="header__item">
            <a href="javascript:;" class="header__link">{{ $t('home.booking') }}</a>

            <ul class="header__sub header__sub--transition">
              <li class="header__sub-item" v-for="location in getLocationsList" :key="location.id">
                <router-link class="header__sub-link" :to="{name: 'Events', params: {id: location.id} }" :style="locationStyles(location.color)">{{ location.title }}</router-link>
              </li>
            </ul>

          </li>

          <!-- <li class="header__item">
            <router-link :to="{name: 'Gallery'}" class="header__link">{{ $t('home.gallery') }}</router-link>
          </li> -->

          <li class="header__item">
            <a href="javascript:;" class="header__link">{{ $t('home.info') }}</a>

            <ul class="header__sub header__sub--transition">
              <li class="header__sub-item" v-for="location in getLocationsList" :key="location.id">
                <router-link class="header__sub-link" :to="{name: 'Infos', params: {id: location.id} }" :style="locationStyles(location.color)">{{ location.title }}</router-link>
              </li>
            </ul>

          </li>

        </ul>
      </nav>

      <!--  Logo  -->
      <router-link :to="{name: 'Home'}">
        <img src="../assets/images/logo.png" alt="Flohmarkt Konig Logo" class="header__logo">
      </router-link>

      <!--  Call2action  -->
      <transition name="trs-fade-out" mode="out-in">
        <div key="1" class="header__c2a" v-if="!isLoggedIn">
          <router-link :to="{name: 'Register'}" class="button button--outline">{{ $t('home.register') }}</router-link>
          <router-link :to="{name: 'Login'}" class="button button--primary">{{ $t('home.login') }}</router-link>
        </div>

        <div key="2" class="header__c2a" v-else>
          <a href="javascript:;" @click.stop="toggleProfileHandler"  class="header__account">
            <img :src="profileImageSrc" alt="" />
            <p class="header__account-info">
              <span>{{ getUserFullName }}</span>
              <icon symbol="icon-down-arrow" />
            </p>
          </a>
          <transition name="trs-fade-out-fast" mode="in-out">
            <ul class="header__sub" v-if="isOpened" click.stop>
              <li class="header__sub-item" v-for="profile in profileLinks" :key="profile.title">
                <a href="#" class="header__sub-link" @click.prevent="changeRoute(profile.path)">{{ profile.title }}</a>
              </li>
              <li class="header__sub-item">
                <a href="#" class="header__sub-link" @click.prevent="logoutClickHandler">{{ $t('profile.logout') }}</a>
              </li>
            </ul>
          </transition>
        </div>
      </transition>

      <!-- Hamburger Navigation -->
      <button class="hamburger hamburger--slider" :class="{'is-active': getToggleMobileNavStatus}" type="button" @click="toggleMobileNavHandler">
        <span class="hamburger-box">
          <span class="hamburger-inner" />
        </span>
      </button>

    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'AppHeader',
  data() {
    return {
      isOpened: false,
      profileLinks: [
        {
          title: this.$t('profile.myProfile'),
          path: { name: 'Profile.account' }
        },
        {
          title: this.$t('profile.myBooking'),
          path: { name: 'Profile.my-events' }
        },
      ]
    }
  },
  watch: {
    '$route'() {
      this.isOpened = false
    }
  },
  computed: {
    ...mapGetters('locations', ['getLocationsList']),
    ...mapGetters('toggleMobileNav', ['getToggleMobileNavStatus']),
    ...mapGetters('auth', ['isLoggedIn', 'getCurrentUser']),
    placeHolderImage() {
      return require('../assets/images/placeholder.png')
    },
    profileImageSrc() {
      const user = this.getCurrentUser || null;
      const base = process.env.VUE_APP_API_BASE_URL || '';
      if (!user || !user.imagepath) return this.placeHolderImage;
      try {
        const target = new URL(user.imagepath);
        const baseUrl = new URL(base);
        return baseUrl.origin + target.pathname + target.search + target.hash;
      } catch (e) {
        if (typeof user.imagepath === 'string') {
          if (user.imagepath.startsWith('http://') || user.imagepath.startsWith('https://')) {
            return user.imagepath;
          }
          const sep = user.imagepath.startsWith('/') ? '' : '/';
          return base + sep + user.imagepath;
        }
        return this.placeHolderImage;
      }
    },
    getUserFullName() {
      let { firstname, lastname } = this.getCurrentUser;
      return `${firstname}`
    }
  },
  mounted() {
    this.fetchLocations()
    document.documentElement.addEventListener('click', () => this.isOpened = false)
  },
  methods: {
    ...mapActions('locations', ['fetchLocations']),
    ...mapActions('toggleMobileNav', ['toggleMobileNavHandler']),
    ...mapActions('auth', ['logoutHandler']),
    locationStyles(color) {
      return {
        '--color': color,
        '--color-hover': color
      }
    },
    logoutClickHandler() {
      this.logoutHandler()
    },
    toggleProfileHandler() {
      this.isOpened = !this.isOpened
    },
    changeRoute(name) {
      this.toggleProfileHandler();
      this.$router.push(name).catch(()=>{});
    }
  }
}
</script>
